module.exports = __webpack_public_path__ + "img/1@2x.cd1a7e9b.png";